// extracted by mini-css-extract-plugin
module.exports = {"viewer":"Notes_viewer__D9ouE"};